import { RouterStateSnapshot, ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from "@angular/core";
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { Observable, of } from 'rxjs';
import { detalleRequested } from '../store/detalle/detalle.actions';



@Injectable()
export class DetalleResolver implements Resolve<any> {

	constructor( private store: Store<AppState> ) {
	}

	resolve( route: ActivatedRouteSnapshot, state: RouterStateSnapshot ): Observable<any> {
		const rid: string = route.paramMap.get('rid');
		this.store.dispatch( detalleRequested( { contenidoRid: rid } ) );
		return of( 'NONE' );
	}
}